export default __webpack_public_path__ + "static/Video-Sharing-Heartfelt-Stories-ffcfba935cda11e3bac0904bac6930a7.jpg";